module.exports = __webpack_public_path__ + "static/stalvart-39aa4266f21e69414ea0f4154178e262.jpg";